// import React, { useEffect, useState } from "react";
// import { Check, MapPin } from "lucide-react";
// import { useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchoneroute, routeSelector } from "../../api/route";

// export function RouteTracking({

//   rideId = "R1D3X458",
//   currentCheckpoint = 0,
//   checkpoints = [
//     { name: "Start Point", estimatedTime: "0 min" },
//     { name: "Downtown", estimatedTime: "10 min" },
//     { name: "City Center", estimatedTime: "20 min" },
//     { name: "Business Park", estimatedTime: "35 min" },
//     { name: "Airport", estimatedTime: "45 min" },
//   ],
// }
// ) {
//   const { routeid } = useParams();
//   const { current_route } = useSelector(routeSelector)
//   console.log(routeid)
//   console.log(current_route)
//   const dispatch = useDispatch();
//   useEffect(() => {
//     const datastuff = dispatch(fetchoneroute(routeid))
//     console.log(datastuff)

//   }, [routeid])
//   if (checkpoints.length === 0) {
//     return <div className="text-center text-muted-foreground">No checkpoints available for this route.</div>;
//   }
//   const handleSelectroute = (routeid) => {
//     console.log("selected specific route",routeid)
//   }
//   const convertToHoursMinutes = (timeInHours) => {
//     const hours = Math.floor(timeInHours); // Get the whole hours
//     const minutes = Math.round((timeInHours - hours) * 60); // Convert decimal part to minutes
//     return `${hours} hrs & ${minutes} mins`;
//   };




//   return (
//     <div className="w-full max-w-3xl mx-auto p-6 bg-background">
//       {/* Ride ID and ETA */}
//       <div className="flex justify-between items-center mb-8">
//         <div className="text-sm">
//           ROUTE ID - <span className="font-medium">{current_route?.route_id}{console.log('current route selected is ', current_route)}</span>
//         </div>
//         <div className="text-sm">
//           <span className="text-muted-foreground">ETA:</span>
//           <span className="ml-1 font-medium text-primary">{convertToHoursMinutes(((current_route?.no_of_kms) * 0.75) / 60)}</span>
//         </div>
//       </div>

   
      
//       <div className="relative">
//         {/* Vertical Line */}
//         <div className="absolute top-0 bottom-0 left-5 w-0.5 bg-muted" />
//         <div className="flex items-center mb-8 last:mb-0">
//           <div className="w-10 h-10 rounded-full flex items-center justify-center z-10 border-4 border-primary bg-white ring-2 ring-primary ring-offset-2" >
//           <MapPin
//             className={`w-5 h-5 "text-primary" 
//                       }`}
//           />
//         </div>
//         <div className="ml-4 flex-grow">
//                 <div
//                   className={`text-sm font-medium "text-foreground" : "text-muted-foreground"
//                     }`}
//                 >
//                   {current_route?.from_location?.name}
//                 </div>
//                 <div className="text-xs text-muted-foreground mt-1">Starting Location</div>
//               </div>
//         </div>
//         {(current_route?.stops)?.map((checkpoint, index) => {


//           return (
//             <div key={index} className="flex items-center mb-8 last:mb-0">
//               <div className="w-10 h-10 rounded-full flex items-center justify-center z-10 transition-colors duration-200">
//                 <MapPin
//                   className={`w-5 h-5 "text-primary" 
//                       }`}
//                 />
//               </div>
//               <div className="ml-4 flex-grow">
//                 <div
//                   className={`text-sm font-medium "text-foreground" : "text-muted-foreground"
//                     }`}
//                 >
//                   {checkpoint?.stop_location?.name}
//                 </div>
//                 <div className="text-xs text-muted-foreground mt-1">Estimated time: {convertToHoursMinutes(((checkpoint?.kms_from_start) * 0.75) / 60)} </div>
//               </div>


//             </div>
//           );
//         })}
//            <div className="flex items-center mb-8 last:mb-0">
//           <div className="w-10 h-10 rounded-full flex items-center justify-center z-10 border-4 border-primary bg-white ring-2 ring-primary ring-offset-2" >
//           <MapPin
//             className={`w-5 h-5 "text-primary" 
//                       }`}
//           />
//         </div>
//         <div className="ml-4 flex-grow">
//                 <div
//                   className={`text-sm font-medium "text-foreground" : "text-muted-foreground"
//                     }`}
//                 >
//                   {current_route?.to_location?.name}
//                 </div>
//                 <div className="text-xs text-muted-foreground mt-1">Estimated time: {convertToHoursMinutes(((current_route?.no_of_kms) * 0.75) / 60)} </div>
//               </div>
//         </div>
//       </div>
      
      
//       <div className="flex justify-center items-center m-16">
//         <button className="bg-[#062D51] text-white px-6 py-3 rounded-full font-semibold shadow-md hover:bg-[#084075] transition duration-300"
//           onClick={() => {
//             handleSelectroute(routeid)
//           }}>
//           Set this Route as your Main
//         </button>
//       </div>


//     </div>
//   );
// }

// export default RouteTracking;
import React, { useEffect, useState } from "react";
import { Check, MapPin } from "lucide-react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { fetchoneroute, routeSelector } from "../../api/route";
//import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Radio, FormControl, FormControlLabel, FormLabel, RadioGroup } from "@mui/material";
import { driverSelector, fetchOnedriver, updatedriver } from "../../api/driver";
import { vehicleSelector, updatevehicle } from "../../api/vehicle";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Checkbox,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  Divider
} from "@mui/material";
import axios from "axios";
import { keyUri } from "../../key";
import { toast } from "react-toastify";

export function RouteTracking() {
  const { routeid } = useParams();
  const navigate = useNavigate();

  const { current_route } = useSelector(routeSelector);
  const {driverData} = useSelector(driverSelector);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false); // Modal state
  const [vehicles, setVehicles] = useState([]); // Driver's vehicles
    const [selectedVehicle, setSelectedVehicle] = useState("");
  const [schedules, setSchedules] = useState([]); // fetched from backend
  const [selectedSchedules, setSelectedSchedules] = useState([]);
  const [pricePerTrip, setPricePerTrip] = useState("");
  const [pricePerKM, setPricePerKM] = useState("");// Selected vehicle

  // Helper: parse "HH:mm" to minutes
const parseMinutes = (timeStr) => {
  if (!timeStr) return 0;
  const [h, m] = timeStr.split(":").map(Number);
  return h * 60 + m;
};

// Helper: parse "1hr 30min" to minutes
const parseDurationToMinutes = (durationStr) => {
  if (!durationStr) return 0;
  let total = 0;
  const hrMatch = durationStr.match(/(\d+)\s*hr/);
  const minMatch = durationStr.match(/(\d+)\s*min/);
  if (hrMatch) total += parseInt(hrMatch[1], 10) * 60;
  if (minMatch) total += parseInt(minMatch[1], 10);
  return total;
};

const bufferMinutes = 30; // buffer time between schedules

// Build array of selected schedule ranges {start, end}
// Build array of selected schedule ranges with 2x multipliers
const selectedRanges = selectedSchedules.map((id) => {
  const sch = schedules.find((s) => s._id === id);
  if (!sch) return null;
  const start = parseMinutes(sch.start);
  const duration = parseDurationToMinutes(current_route?.duration || "");
  
  // Block range: selected_start ± (2*duration + 2*buffer)
  return { 
    start: start - (2 * duration) - (2 * bufferMinutes), 
    end: start + (2 * duration) + (2 * bufferMinutes) 
  };
}).filter(Boolean);

// Function to check if a schedule conflicts with selected ranges
const isScheduleConflicting = (sch) => {
  const candidateStart = parseMinutes(sch.start);
  
  // Check if candidate's start falls within any blocked range
  return selectedRanges.some(({ start: blockStart, end: blockEnd }) => 
    candidateStart > blockStart && candidateStart < blockEnd
  );
};

// Function to check if a schedule conflicts with selected ranges
/*const isScheduleConflicting = (sch) => {
  const start = parseMinutes(sch.start);
  const duration = parseDurationToMinutes(current_route?.duration || "");
  const candidateEnd = start + (2 * duration) + (2 * bufferMinutes);

  return selectedRanges.some(({ start: rStart, end: rEnd }) => 
    start < rEnd && rStart < candidateEnd
  );
}; */

  
  useEffect(() => {
    dispatch(fetchoneroute(routeid));
    const driverid = localStorage.getItem("Driver");
    dispatch(fetchOnedriver(driverid));

    // fetch schedules for this route
    if (routeid) {
      axios
        .get(`${keyUri.BACKEND_URI}/api/get-route/${routeid}`)
        .then((res) => {
          setSchedules(res.data?.schedules || []);
        })
        .catch((err) => console.error("Error fetching schedules:", err));
    }
  }, [routeid, dispatch]);

  

  const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);

const handleConfirmRoute = async () => {
  if (!selectedVehicle || selectedSchedules.length === 0 || !pricePerTrip) {
    alert("Please select a vehicle, at least one schedule, and enter a price.");
    return;
  }

  // Find which vehicle currently holds this route
  const oldVehicle = driverData?.vehicleId?.find(vehicle =>
    vehicle.selected_schedules?.some(s => s.route === current_route._id)
  );

 console.log("Selected Schedules before update:", selectedSchedules);

const payload = {
  routeIdToAssign: current_route._id,
  oldVehicleId: oldVehicle?._id || null,
  newVehicleId: selectedVehicle,
  selected_schedules: [
    {
      route: current_route._id,
      schedules: selectedSchedules,  // <-- must be non-empty array of schedule IDs
      price_per_Trip: Number(pricePerTrip),
    },
  ],
  pricePerTrip: Number(pricePerTrip),
};
  try {
    await dispatch(updatevehicle(payload, selectedVehicle));
    toast.success("Route reassigned successfully!");
    setOpen(false);
  } catch (err) {
    console.error("Failed to update route assignment:", err);
    toast.error("Failed to update route assignment");
  }
};


  const convertTime = (kms) => {
    if (!kms) return "0 hours";

    const totalHours = (kms * 0.75) / 60;
    const hours = Math.floor(totalHours); 
    const minutes = Math.round((totalHours - hours) * 60); 

    if (minutes === 0) {
        return `${hours} ${hours === 1 ? "hour" : "hours"}`; 
    } else {
        return `${hours} ${hours === 1 ? "hour" : "hours"} ${minutes} minutes`;
    }
};

{/*
useEffect(() => {
  if (!driverData || !current_route) return;

  const vehicles = driverData.vehicleId || [];

  // Find the vehicle which has the current route assigned
  const assignedVehicle = vehicles.find(v =>
    v.route_id?.includes(current_route._id)
  );

  if (assignedVehicle) {
    setSelectedVehicle(assignedVehicle.reg_no || "");

    // Find the selected_schedules object for this route
    const routeSchedules = assignedVehicle.selected_schedules?.find(
      (s) => s.route === current_route._id
    );

  if (routeSchedules) {
  const scheduleIds = routeSchedules.schedules.map(s =>
    typeof s === "string" ? s : s._id
  );

  // Only keep IDs that exist in schedules fetched from backend
  const validIds = scheduleIds.filter(id => schedules.some(s => s._id === id));

  setSelectedSchedules(validIds);
  setPricePerTrip(routeSchedules.price_per_Trip || "");
}

  }
}, [driverData, current_route]); */}

useEffect(() => {
  console.log("🚀 Prefill effect triggered...");

  if (!driverData?.vehicleId || driverData.vehicleId.length === 0) {
    console.log("❌ No vehicles found for driver yet.");
    return;
  }
  if (!current_route?._id) {
    console.log("❌ No current route selected yet.");
    return;
  }

  console.log("✅ Driver Vehicles:", driverData.vehicleId);
  console.log("✅ Current Route:", current_route);

  // Find assigned vehicle that already has this route
  const assignedVehicle = driverData.vehicleId.find((vehicle) => {
    console.log("🔍 Checking Vehicle:", vehicle.reg_no, "with schedules:", vehicle.selected_schedules);

    if (!vehicle.selected_schedules || vehicle.selected_schedules.length === 0) {
      return false;
    }

    return vehicle.selected_schedules.some((s) => s.route === current_route._id);
  });

  console.log("🎯 Assigned Vehicle Found:", assignedVehicle);

  if (assignedVehicle) {
    setSelectedVehicle(assignedVehicle._id);

    const routeSchedules = assignedVehicle.selected_schedules.find(
      (s) => s.route === current_route._id
    );

    if (routeSchedules) {
      const scheduleIds = routeSchedules.schedules.map((s) =>
        typeof s === "string" ? s : s._id
      );

      // Only keep IDs that exist in schedules from backend
      const validIds = scheduleIds.filter((id) => schedules.some((sch) => sch._id === id));

      setSelectedSchedules(validIds);
       // Prefill price
    const tripPrice =
      routeSchedules.price_per_Trip ??
      routeSchedules.pricePerTrip ??
      "";

    console.log("💰 Prefilled Price:", tripPrice);
    if (typeof tripPrice === "object" && tripPrice.$numberDecimal) {
  setPricePerTrip(tripPrice.$numberDecimal);
} else {
  setPricePerTrip(tripPrice);
}

    }
  }
}, [driverData, current_route, schedules]);

useEffect(() => {
  if (!routeid) return; // Prevent running if no routeid (like when on "/")
  dispatch(fetchoneroute(routeid));
}, [routeid, dispatch]);



console.log("Assigned Routes:", driverData?.assignedRoute);

console.log("Driver Data:", driverData);

const [openScheduleDropdown, setOpenScheduleDropdown] = useState(false);
//console.log('Updating schedules:', selected_schedules);

  return (
    <div className="w-full max-w-3xl mx-auto p-6 bg-background mt-40">
      {/* Route ID and ETA */}
      {/* {console.log('',driverData)} */}
      <div className="flex justify-between items-center mb-8">
        <div className="text-sm">
          ROUTE ID - <span className="font-medium">{current_route?.route_id}</span>
        </div>
        <div className="text-sm">
          <span className="text-muted-foreground">ETA:</span>
          <span className="ml-1 font-medium text-primary">
            {current_route?.duration}
          </span>
        </div>
      </div>

      {/* Route Stops */}
      <div className="relative">
        <div className="absolute top-0 bottom-0 left-5 w-0.5 bg-muted" />
        <div className="flex items-center mb-8 last:mb-0">
          <div className="w-10 h-10 rounded-full flex items-center justify-center z-10 border-4 border-primary bg-white ring-2 ring-primary ring-offset-2">
            <MapPin className="w-5 h-5 text-primary" />
          </div>
          <div className="ml-4 flex-grow">
            <div className="text-sm font-medium">{current_route?.from_location?.name}</div>
            <div className="text-xs text-muted-foreground mt-1">Starting Location</div>
          </div>
        </div>

        {current_route?.stops?.map((checkpoint, index) => (
          <div key={index} className="flex items-center mb-8 last:mb-0">
            <div className="w-10 h-10 rounded-full flex items-center justify-center z-10">
              <MapPin className="w-5 h-5 text-primary" />
            </div>
            <div className="ml-4 flex-grow">
              <div className="text-sm font-medium">{checkpoint?.stop_location?.name}</div>
              <div className="text-xs text-muted-foreground mt-1">
                ETA: {convertTime(checkpoint?.kms_from_start )} 
              </div>
            </div>
          </div>
        ))}

        <div className="flex items-center mb-8 last:mb-0">
          <div className="w-10 h-10 rounded-full flex items-center justify-center z-10 border-4 border-primary bg-white ring-2 ring-primary ring-offset-2">
            <MapPin className="w-5 h-5 text-primary" />
          </div>
          <div className="ml-4 flex-grow">
            <div className="text-sm font-medium">{current_route?.to_location?.name}</div>
            <div className="text-xs text-muted-foreground mt-1">
              ETA: {current_route?.duration}
            </div>
          </div>
        </div>
      </div>

      {/* BUTTON - OPEN MODAL */}
      <div className="flex justify-center items-center m-16">
        <button
          className="bg-[#062D51] text-white px-6 py-3 rounded-full font-semibold shadow-md hover:bg-[#084075] transition duration-300"
          onClick={handleOpenModal}
        >
          Set this Route as your Main
        </button>
      </div>

      {/* MODAL (POPUP) */}
      <Dialog open={open} onClose={handleCloseModal} maxWidth="sm" fullWidth>
        <DialogTitle>Confirm Route Selection</DialogTitle>
        <DialogContent>
          <p><strong>Route ID:</strong> {current_route?.route_id}</p>
          <p><strong>From:</strong> {current_route?.from_location?.name}</p>
          <p><strong>To:</strong> {current_route?.to_location?.name}</p>
          <p><strong>Total Distance:</strong> {current_route?.no_of_kms} km</p>
          <p><strong>Estimated Time:</strong> {current_route?.duration}</p>

          {/* VEHICLE SELECTION */}
          <FormControl component="fieldset" style={{ marginTop: "20px" }}>
            <FormLabel component="legend">Select a Vehicle</FormLabel>
            <RadioGroup value={selectedVehicle} onChange={(e) => setSelectedVehicle(e.target.value)}>
              {driverData?.vehicleId?.map((vehicle) => (
                <FormControlLabel key={vehicle?._id} value={vehicle?._id} control={<Radio />} label={vehicle?.reg_no} />
              ))}
            </RadioGroup>
          </FormControl>
                   {/* SCHEDULE SELECTION */}
          <FormControl fullWidth margin="normal">
            <InputLabel  shrink={selectedSchedules.length > 0}
            id="select-schedules-label">Select Schedules</InputLabel>
            <Select
            labelId="select-schedules-label"
              multiple
               open={openScheduleDropdown}
    onOpen={() => setOpenScheduleDropdown(true)}
    onClose={() => setOpenScheduleDropdown(false)}
              value={selectedSchedules}
              onChange={(e) => {
  const value = typeof e.target.value === "string" ? e.target.value.split(",") : e.target.value;
  console.log("Selected schedules updated to:", value);
  setSelectedSchedules(value);
}}
              renderValue={(selected) =>
                schedules
                  .filter((sch) => selected.includes(sch._id))
                  .map((sch) => `${sch.start}`)
                  .join(", ")
              }
               label="select-schedules-label"
            >
            { schedules.map((sch) => {
  const disabled = !selectedSchedules.includes(sch._id) && isScheduleConflicting(sch);
  return (
    <MenuItem key={sch._id} value={sch._id} disabled={disabled}>
      <Checkbox
        checked={selectedSchedules.includes(sch._id)}
        disabled={disabled}
      />
      {sch.start}
    </MenuItem>
  );
})}


                {/* ✅ OK button inside dropdown */}
 {/* Divider for separation */}
    <Divider />

    {/* ✅ Nice OK button */}
    <MenuItem disableRipple>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={() => setOpenScheduleDropdown(false)}
      >
        OK
      </Button>
    </MenuItem>
            </Select>
          </FormControl>

          
          
<TextField
  fullWidth
  margin="normal"
  type="number"
  label="Price per Trip (₹)"
  variant="filled"   // or "standard"
  value={pricePerTrip ?? ""}
  onChange={(e) => setPricePerTrip(e.target.value)}
/>



         
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="secondary">Cancel</Button>
          <Button onClick={handleConfirmRoute} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default RouteTracking;
